const genderOptions = [
  { id: null, label: 'Indifférent', labelEn: ' Indifferent ', value: null },
  { id: 2, label: 'Femme', labelEn: 'Woman', value: 'F' },
  { id: 3, label: 'Homme', labelEn: 'Man', value: 'H' },
  { id: 4, label: 'Non binaire', labelEn: 'Non-binary', value: 'NB' },
]

const typeDocumentOptions = [
  { id: null, label: 'Indifférent', labelEn: ' Indifferent ', value: null },
  { id: 1, label: 'Livre', labelEn: 'Book', value: 'livre' },
  { id: 2, label: 'Périodique', labelEn: 'Periodical', value: 'periodique' },
  { id: 3, label: 'CD', labelEn: 'CD', value: 'cd' },
  { id: 4, label: 'Vinyle', labelEn: 'Vinyl', value: 'vinyl' },
  { id: 5, label: 'Partition', labelEn: 'Score', value: 'partition' },
  {
    id: 6,
    label: 'Note de programme',
    labelEn: 'Program note',
    value: 'program',
  },
  {
    id: 7,
    label: 'Thèse et mémoire',
    labelEn: 'Thesis and dissertation',
    value: 'thesis',
  },
]

export function getAdvancedSearchFields(t, locale, personHelpers, workHelpers) {
  const { countries, birthDateMin, birthDateMax, deathDateMin, deathDateMax } =
    personHelpers
  const {
    thesauri,
    durationMin,
    durationMax,
    creationMin,
    creationMax,
    compositionMin,
    compositionMax,
  } = workHelpers
  const composerFields = [
    {
      id: 1,
      type: 'search',
      label: t('advanced_search.composers.first_name'),
      name: 'firstName',
      model: 'firstName',
      table: 'persons',
      fields: ['firstName'],
      include: ['id', 'firstName'],
      keyValue: 'firstName',
      displayFn: (composer) => composer?.firstName,
    },
    {
      id: 2,
      type: 'search',
      label: t('advanced_search.composers.last_name'),
      name: 'lastName',
      model: 'lastName',
      table: 'persons',
      fields: ['lastName'],
      include: ['id', 'lastName'],
      keyValue: 'lastName',
      displayFn: (composer) => composer?.lastName,
    },
    {
      id: 3,
      type: 'select',
      label: t('advanced_search.composers.gender'),
      placeholder: 'Sélectionnez un genre',
      model: 'gender',
      options: genderOptions,
    },
    {
      id: 4,
      type: 'autocomplete',
      label: t('advanced_search.composers.nationality'),
      name: 'nationalities',
      model: 'nationalities',
      options: countries.value,
      getOption: (country) => country?.id,
      displayFn: (country) => country?.name,
    },
    {
      id: 5,
      type: 'autocomplete',
      label: t('advanced_search.composers.birth_country'),
      name: 'birthCountry',
      model: 'birthCountry',
      options: countries.value,
      getOption: (country) => country?.id,
      displayFn: (country) => country?.name,
    },
    {
      id: 6,
      type: 'autocomplete',
      label: t('advanced_search.composers.death_country'),
      name: 'deathCountry',
      model: 'deathCountry',
      options: countries.value,
      getOption: (country) => country?.id,
      displayFn: (country) => country?.name,
    },

    {
      id: 7,
      type: 'range',
      label: t('advanced_search.composers.birth_date'),
      name: 'birthDate',
      min: birthDateMin.value,
      max: birthDateMax.value,
      step: 1,
      model: 'birthDate',
    },

    {
      id: 8,
      type: 'range',
      label: t('advanced_search.composers.death_date'),
      name: 'deathDate',
      min: deathDateMin.value,
      max: deathDateMax.value,
      step: 1,
      model: 'deathDate',
    },
    {
      id: 9,
      type: 'checkbox',
      label: t('advanced_search.composers.with_workcourse'),

      model: 'withWorkCourse',
    },
  ]
  const floraFields = [
    {
      id: 1,
      type: 'text',
      label: t('advanced_search.physical_objects.title'),
      model: 'title',
      name: 'title',
    },
    {
      id: 2,
      type: 'search',
      label: t('advanced_search.physical_objects.author'),
      name: 'authorsId',
      model: 'authorsId',
      table: 'unimarc_authors',
      fields: ['firstName', 'lastName'],
      include: ['id', 'firstName', 'lastName'],
      displayFn: (author) => `${author?.firstName} ${author?.lastName}`,
    },
    {
      id: 3,
      type: 'search',
      label: t('advanced_search.physical_objects.publisher'),
      name: 'publisher',
      model: 'publisher',
      table: 'editors',
      multiple: true,
      fields: ['name'],
      include: ['id', 'name'],
      keyValue: 'name',
      displayFn: (publisher) => publisher?.name,
    },
    {
      id: 4,
      type: 'search',
      label: t('advanced_search.physical_objects.series'),
      name: 'collection',
      model: 'collection',
      table: 'unimarc_collections',
      fields: ['label'],
      include: ['label'],
      keyValue: 'label',
      displayFn: (collection) => collection?.label,
    },
    {
      id: 5,
      type: 'search',
      label: t('advanced_search.physical_objects.keyword'),
      name: 'subjects',
      model: 'subjects',
      table: 'unimarc_subjects',
      fields: ['label'],
      include: ['label'],
      keyValue: 'label',
      displayFn: (subject) => subject?.label,
    },
    {
      id: 6,
      type: 'select',
      label: t('advanced_search.physical_objects.document_type'),
      model: 'type',
      name: 'type',
      options: typeDocumentOptions,
    },
  ]
  const workFields = [
    {
      id: 1,
      type: 'search',
      label: t('advanced_search.works.composer'),
      name: 'composersId',
      model: 'composersId',
      table: 'persons',
      fields: ['firstName', 'lastName'],
      include: ['id', 'firstName', 'lastName'],
      filterBy: 'isComposer:true',
      displayFn: (composer) => `${composer?.firstName} ${composer?.lastName}`,
    },
    {
      id: 2,
      label: t('advanced_search.works.original_title'),
      type: 'text',
      model: 'title',
    },
    {
      id: 3,
      type: 'text',
      label: t('advanced_search.works.french_title'),

      model: 'titleFr',
    },
    {
      id: 4,
      type: 'text',
      label: t('advanced_search.works.description'),
      model: 'description',
    },

    {
      id: 5,
      type: 'range',
      label: t('advanced_search.works.duration'),
      name: 'duration',
      max: durationMax.value,
      min: durationMin.value,
      step: 30,
      placeholder: null,
      model: 'duration',
    },
    {
      id: 6,
      type: 'range',
      label: t('advanced_search.works.composition_year'),
      name: 'compositionYear',
      max: compositionMax.value,
      min: compositionMin.value,
      placeholder: null,
      step: 1,
      model: 'compositionYear',
    },
    {
      id: 7,
      type: 'text',
      label: t('advanced_search.works.part_title'),

      model: 'partsTitle',
    },
    {
      id: 8,
      type: 'text',
      label: t('advanced_search.works.libretto'),
      model: 'libretto',
    },
    {
      id: 9,
      type: 'range',
      label: t('advanced_search.works.creation_year'),
      name: 'creationYear',
      max: creationMax.value,
      min: creationMin.value,
      step: 1,
      placeholder: null,
      model: 'creationYear',
    },
    {
      id: 10,
      type: 'text',
      label: t('advanced_search.works.creation_location'),

      model: 'creationLocation',
    },
    {
      id: 11,
      type: 'text',
      label: t('advanced_search.works.interpreters'),

      model: 'interpreters',
    },
    {
      id: 12,
      type: 'search',
      label: t('advanced_search.works.musical_assistants'),
      name: 'assistants',
      model: 'assistants',
      table: 'musical_assistants',
      fields: ['firstName', 'lastName'],
      include: ['id', 'firstName', 'lastName'],
      displayFn: (musicalAssistant) =>
        `${musicalAssistant?.firstName} ${musicalAssistant.lastName}`,
    },
    {
      id: 13,
      type: 'text',
      label: t('advanced_search.works.information_studio'),
      placeholder: null,
      model: 'studioInformation',
    },
    {
      id: 14,
      type: 'checkbox',
      label: t('advanced_search.works.arrangment'),
      model: 'arrangement',
    },
    {
      id: 15,
      type: 'checkbox',
      label: t('advanced_search.works.ircam'),
      model: 'ircam',
    },
    {
      id: 16,
      type: 'checkbox',
      label: t('advanced_search.works.ircam_curriculum'),
      model: 'ircamCurriculum',
    },
    {
      id: 17,
      type: 'checkbox',
      label: t('advanced_search.works.electronic'),
      model: 'electronic',
    },
    {
      id: 18,
      type: 'search',
      label: t('advanced_search.works.scenic'),
      name: 'scenic',
      model: 'scenic',
      table: 'scenics',
      fields: ['nameFr', 'nameEn'],
      include: ['id', 'nameFr', 'nameEn'],
      displayFn: (scenic) =>
        locale.value === 'fr' ? scenic?.nameFr : scenic?.nameEn,
    },
    {
      id: 19,
      type: 'search',
      label: t('advanced_search.works.publisher'),
      name: 'publisher',
      model: 'publisher',
      table: 'publishers',
      fields: ['name'],
      include: ['id', 'name'],
      displayFn: (publisher) => publisher?.name,
    },
    {
      id: 20,
      type: 'text',
      label: t('advanced_search.works.commanditary'),
      placeholder: null,
      model: 'commanditary',
    },
    {
      id: 21,
      type: 'text',
      label: t('advanced_search.works.dedicatee'),
      placeholder: null,
      model: 'dedicatee',
    },
    {
      id: 22,
      type: 'search',
      label: t('advanced_search.works.kind'),
      name: 'genres',
      model: 'genres',
      table: 'genres',
      fields: ['nameFr', 'nameEn'],
      include: ['id', 'nameFr', 'nameEn'],
      displayFn: (genre) =>
        locale.value === 'fr' ? genre?.nameFr : genre?.nameEn,
    },
    {
      id: 23,
      type: 'autocomplete',
      label: t('advanced_search.works.with_instruments'),
      name: 'withInstruments',
      options: thesauri.value,
      model: 'withInstruments',
      multiple: true,
      getOption: (instrument) => instrument?.slug,
      displayFn: (instrument) =>
        locale.value === 'fr' ? instrument?.nameFr : instrument?.nameEn,
    },
    {
      id: 24,
      type: 'autocomplete',
      label: t('advanced_search.works.without_instruments'),
      name: 'without Instruments',
      options: thesauri.value,
      model: 'withoutInstruments',
      multiple: true,
      getOption: (instrument) => instrument?.slug,
      displayFn: (instrument) =>
        locale.value === 'fr' ? instrument?.nameFr : instrument?.nameEn,
    },
  ]
  return { composerFields, floraFields, workFields }
}

export function getAdvancedSearchValues() {
  const initComposerValues = {
    id: null,
    firstName: null,
    lastName: null,
    gender: null,
    nationalities: [],
    birthCountry: [],
    deathCountry: [],
    withWorkCourse: null,
    birthDate: {
      minValue: null,
      maxValue: null,
      range: false,
    },
    deathDate: {
      minValue: null,
      maxValue: null,
      range: false,
    },
  }
  const initWorkValues = {
    id: null,
    title: null,
    titleFr: null,
    partsTitle: null,
    description: null,
    libretto: null,
    creationLocation: null,
    interpreters: null,
    commanditary: null,
    dedicatee: null,
    studioInformation: null,
    arrangement: null,
    ircam: null,
    ircamCurriculum: null,
    electronic: null,
    scenic: null,
    composersId: null,
    assistants: null,
    publishers: null,
    genres: null,
    withInstruments: [],
    withoutInstruments: [],
    duration: {
      minValue: null,
      maxValue: null,
      range: true,
    },
    compositionYear: {
      minValue: null,
      maxValue: null,
      range: false,
    },
    creationYear: {
      minValue: null,
      maxValue: null,
      range: false,
    },
  }
  const initFloraValues = {
    title: null,
    authorsId: null,
    publisher: null,
    collection: null,
    subjects: null,
    type: null,
  }
  return { initFloraValues, initComposerValues, initWorkValues }
}
